import { produce } from "immer"
import { remove } from "ramda"
import {
  PROJECT_SELECTOR_DESELECT_COMPARISON,
  PROJECT_SELECTOR_DESELECT_PROJECT,
  PROJECT_SELECTOR_SELECT_COMPARISON,
  PROJECT_SELECTOR_SELECT_PROJECT
} from "./project-selector.actions"
import type {
  IProjectSelectorState,
  ProjectSelectorActions,
  SelectedComparison,
  SelectedProject
} from "./project-selector.types"

const projectSelectorInitialState: IProjectSelectorState = {
  selectedProjects: [],
  selectedComparisons: []
}

export function projectSelectorReducer(
  currentState: IProjectSelectorState | undefined,
  action: ProjectSelectorActions
): IProjectSelectorState {
  const state = currentState ?? projectSelectorInitialState
  switch (action.type) {
    case PROJECT_SELECTOR_SELECT_PROJECT:
      return selectProject(state, action.payload as SelectedProject)
    case PROJECT_SELECTOR_DESELECT_PROJECT:
      return deselectProject(state, action.payload as SelectedProject)
    case PROJECT_SELECTOR_SELECT_COMPARISON:
      return selectComparison(state, action.payload as SelectedComparison)
    case PROJECT_SELECTOR_DESELECT_COMPARISON:
      return deselectComparison(state, action.payload as SelectedComparison)
    default:
      return state
  }
}

function selectProject(currentState: IProjectSelectorState, project: SelectedProject): IProjectSelectorState {
  return produce(currentState, (draftState: IProjectSelectorState) => {
    draftState.selectedProjects.push(project)
  })
}

function deselectProject(currentState: IProjectSelectorState, project: SelectedProject): IProjectSelectorState {
  return produce(currentState, (draftState: IProjectSelectorState) => {
    const index: number = draftState.selectedProjects.findIndex(
      (selectedProject: SelectedProject) => selectedProject.id === project.id
    )
    if (index !== -1) {
      draftState.selectedProjects = remove(index, 1, draftState.selectedProjects)
    }
  })
}

function selectComparison(currentState: IProjectSelectorState, comparison: SelectedComparison): IProjectSelectorState {
  return produce(currentState, (draftState: IProjectSelectorState) => {
    draftState.selectedComparisons.push(comparison)
  })
}

function deselectComparison(
  currentState: IProjectSelectorState,
  comparison: SelectedComparison
): IProjectSelectorState {
  return produce(currentState, (draftState: IProjectSelectorState) => {
    const index: number = draftState.selectedComparisons.findIndex(
      (selectedComparison: SelectedComparison) => selectedComparison.id === comparison.id
    )
    if (index !== -1) {
      draftState.selectedComparisons = remove(index, 1, draftState.selectedComparisons)
    }
  })
}
